import { defineStore } from 'pinia'

import { MOVIES_TOOLSET_PROMPT } from '../../tools/movies'
import { useLlmToolsetPromptsStore } from '../llm-toolset-prompts'

/**
 * 本站影片检索能力（奈何TV 定制）的配套 system prompt。
 *
 * 与 web-search 模块不同，这个工具不需要任何用户配置（端点固定、密钥在服务端），
 * 所以它**始终**可用，规则也就始终挂载。
 *
 * 规则放在 toolset prompt 而不是人设卡里，是为了让「工具存在」和「使用约束」
 * 同生共死 —— 用户改人设卡时不会把「不许编造片名」这条铁律弄丢。
 */
export const useMoviesStore = defineStore('movies', () => {
  const toolsetPromptsStore = useLlmToolsetPromptsStore()

  toolsetPromptsStore.registerToolsetPrompts('movies', [
    { id: 'movies', content: MOVIES_TOOLSET_PROMPT },
  ])

  return {}
})
